/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
/**
 * Provides all nessesary aria-* attributes to create valid aria selection state.
 */
export function ariaSelected() {
    return (target) => target.addInitializer((instance) => new AriaSelectedController(instance));
}
export class AriaSelectedController {
    constructor(host) {
        this.host = host;
        this.host.addController(this);
    }
    hostUpdated() {
        if (this.host.selected !== null && this.host.selected !== undefined) {
            this.host.ariaSelected = this.host.selected ? 'true' : 'false';
        }
    }
}
